import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const OcurrencesMonth = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    const rawData = chartData?.ocurrencesMonth || [];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    const series = [
        {
            name: 'Total',
            data: chartData?.ocurrencesMonth?.map(item => item.total)
        },
        {
            name: 'Madrugada',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_madrugada)
        },
        {
            name: 'Manhã',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_manha)
        },
        {
            name: 'Tarde',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_tarde)
        },
        {
            name: 'Noite',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_noite)
        },
        {
            name: 'Não Identificado',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_nao_identificado)
        }
    ];

    return (
        <SimpleBars
            title={'Período das Ocorrências (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
        />
    );
};